import { render, staticRenderFns } from "./user_list.vue?vue&type=template&id=15b08f9c&scoped=true"
import script from "./user_list.vue?vue&type=script&lang=js"
export * from "./user_list.vue?vue&type=script&lang=js"
import style0 from "./user_list.vue?vue&type=style&index=0&id=15b08f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b08f9c",
  null
  
)

/* custom blocks */
import block0 from "./user_list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports